import { render, staticRenderFns } from "./reNewsAdsList.vue?vue&type=template&id=a4075782&scoped=true"
import script from "./reNewsAdsList.vue?vue&type=script&lang=js"
export * from "./reNewsAdsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4075782",
  null
  
)

export default component.exports